import { Flex, Image, useTheme } from "@aws-amplify/ui-react"
import { isProd, stageName } from "../config"

export default function AuthenticatorHeader() {
  const { tokens } = useTheme()
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      alignContent="center"
      className="!bg-gradient-to-b from-[#25c401] to-[#498e38] !mb-2 !shadow-md"
    >
      <Image
        alt="Strautmann Data System"
        src="/logo-strautmann.svg"
        padding={tokens.space.small}
      />
      <div
        style={{
          fontSize: "47px",
          fontWeight: "bold",
        }}
        className="text-white"
      >
        SDS
        {isProd ? "" : ` /${stageName}`}
      </div>
    </Flex>
  )
}
